<template>
  <div>
    <div class="title pt-2">
      <header-with-tooltip
          v-if="!isOnlyPDFAllowed"
          :tooltip-text=CONSTANTS.ATTACH_DOCUMENT_TOOLTIP
          :isHTML="true"
          :show-icon="true">
        <span class="mr-1" :class="{ 'required-field' : isRequired }">{{ attachmentTitle }}</span>
      </header-with-tooltip>
      <div v-else :class="{ 'required-field' : isRequired }">{{ attachmentTitle }}</div>
    </div>
    <div class="font-italic">
      <span v-if="isOnlyPDFAllowed">Allowed File types: PDF<br></span>
      Maximum file size allowed: {{maxFileSizeInMb}}MB (in total)
    </div>
    <invoice-upload 
      :existing-files="existingFiles"
      :max-file-size-in-bytes="maxFileSizeInBytes"
      @onFileUploaded="onFileUploaded"
      :validFileTypes="validFileTypes"
      :multipleSelectionAllowed="multipleSelectionAllowed"
      :check-for-file-support="checkForFileSupport"
    />
    <attachments-viewer
      v-if="attachments && attachments.length > 0"
      :viewFileAttachment="viewAttachment"
      :attachments="attachments"
      @onFileDeleted="onFileDeleted"
      :is-preview-mode="false"
    />
  </div>
</template>

<script>
import InvoiceUpload from "./InvoiceUpload";
import HeaderWithTooltip from "../HeaderWithTooltip";
import AttachmentsViewer from "./AttachmentsViewer";
import PaymentFormsMixin from "../../mixins/PaymentFormsMixin";
import CONSTANTS from "@/store/constants";
export default {
  name: "attachInvoice",
  props: ["data", "maxFileSizeInMb", "isRequired","attachmentTitle","validFileTypes","viewAttachment","multipleSelectionAllowed","checkForFileSupport"],
  mixins: [PaymentFormsMixin],
  components: { InvoiceUpload, AttachmentsViewer,HeaderWithTooltip},
  computed: {
    maxFileSizeInBytes() {
      return this.maxFileSizeInMb ? (this.maxFileSizeInMb * 1000000) : undefined
    },
    existingFiles() {
      let attachments = this.attachments
      let files = []
      attachments.forEach(attachment => {
        files.push({fileName: attachment.fileName, fileSize: attachment.fileSize})
      })
      return files
    },
    isOnlyPDFAllowed() {
      return this.validFileTypes === CONSTANTS.FILE_TYPES.extensionAsPdf.validFileTypes
    }
  },
  data() {
    return {
      attachments: this.data.attachments ? this.data.attachments : []
    };
  },
  methods: {
    onFileUploaded(uploadedFileId, uploadedFileName, uploadedFileSize) {
      let attachment = {
        fileId: uploadedFileId,
        fileName: uploadedFileName,
        fileSize: uploadedFileSize
      };
      this.attachments.push(attachment);
      this.$emit("onInvoiceUploaded", this.attachments);
    },
    onFileDeleted(removeAttachment) {
      this.attachments = this.attachments.filter(
        attachment => attachment.fileId != removeAttachment.fileId
      );
      this.$emit("onInvoiceDeleted", removeAttachment);
    }
  }
};
</script>